<template>
    <div class="auto-slider" :class="rootClasses">
        <div class="auto-slider--container swiper-container" ref="slider">
            <div class="auto-slider--slider-wrapper swiper-wrapper">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>

    import Swiper from 'swiper';
    import { getViewportData } from 'util/dom/mq';
    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('auto-slider')],
        props: {
            autoplay: {
                type: Boolean,
                default: true,
            },


            itemCount: {
                type: Number,
                required: true,
            },

            breakpoints: {
                type: Object,
                default: () => {
                    return {
                        xl: 5,
                        lg: 3,
                        md: 3,
                        sm: 2,
                        xs: 1,
                    };
                },
            },
        },

        data() {
            return {
                swiper: null,
            };
        },


        computed: {
            rootClasses() {
                return [
                    this.bemAdd(this.isSwiperEnabled ? null : 'no-swiper'),
                ];
            },

            isSwiperEnabled() {
                const currentWidth = getViewportData().query;
                return this.breakpoints[currentWidth] <= this.itemCount;
            },
        },

        beforeDestroy() {
            this.swiper.destroy();
        },


        mounted() {
            if (!this.isSwiperEnabled) {
                return;
            }

            const config = {
                allowTouchMove: false,
                preventInteractionOnTransition: true,
                speed: 5000,
                loop: true,
                slidesPerView: 'auto',
            };

            if (this.autoplay) {
                config.autoplay = {
                    delay: 0,
                };
            }

            this.swiper = new Swiper(this.$refs.slider, config);
        },
    };
</script>
